// extracted by mini-css-extract-plugin
export default {"item":"NavigationItem_item__E6CEu","button":"NavigationItem_button__wGQBH","itemWrapper":"NavigationItem_itemWrapper__P6eOb","dark":"NavigationItem_dark__GJlO4"};